import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { useMutation } from '@apollo/client';
import * as Yup from 'yup';
import Link from 'next/link';
import InputField from 'components/Form/InputField';
import SubmitButton from 'components/Form/SubmitButton';
import FormSubmitErrors from 'components/Form/FormSubmitErrors';
import breakPoints from 'helpers/Styles';
import CUSTOMER_RECOVER_MUTATION from './graph';

const RequestForm = ({ onCancle, onSuccess }) => {
  const [recoverCustomer, { error, data }] = useMutation(
    CUSTOMER_RECOVER_MUTATION,
  );

  return (
    <div className="reset-password-request-from-container">
      <h1 className="heading_style__hero">Reset your password</h1>
      <p className="reset_description">
        We will send you an email to reset your password
      </p>
      <Formik
        initialValues={{ email: '' }}
        validationSchema={Yup.object({
          email: Yup.string()
            .email('Invalid email address')
            .required('Required'),
        })}
        onSubmit={(values, { setSubmitting }) => {
          recoverCustomer({
            variables: { email: values.email },
            update(proxy, { data: { customerRecover } }) {
              setSubmitting(false);
              if (customerRecover.customerUserErrors.length === 0) {
                onSuccess();
              }
            },
            onerror() {
              setSubmitting(false);
            },
          }).catch(() => {
            setSubmitting(false);
          });
        }}
      >
        {({ isSubmitting }) => (
          <>
            {data && data.customerRecover.customerUserErrors ? (
              <FormSubmitErrors
                errors={data.customerRecover.customerUserErrors}
              />
            ) : null}
            {error ? (
              <FormSubmitErrors
                errors={[
                  { message: 'Something went wrong. Please try again.' },
                ]}
              />
            ) : null}
            <Form>
              <InputField
                type="email"
                name="email"
                placeholder="Email Address"
                autoComplete="username"
                autoFocus
              />

              <div className="action_buttons">
                {' '}
                <button
                  type="button"
                  onClick={onCancle}
                  className="cancel_button"
                >
                  Cancel
                </button>
                <SubmitButton
                  isSubmitting={isSubmitting}
                  label="Submit"
                  submitLabel="Submitting.."
                />
              </div>

              <Link href="/me/sign-up">
                <a
                  href="/me/sign-up"
                  alt="sign up"
                  className="extra-action_signup"
                >
                  SIGN UP
                </a>
              </Link>
            </Form>
          </>
        )}
      </Formik>
      <style jsx>
        {`
          .reset_description {
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: center;
          }
          .reset-password-request-from-container {
            max-width: 460px;
            margin: 0 auto;
            text-align: center;
            padding-top: 62px;
            padding-bottom: 100px;
          }
          .heading_style__hero {
            color: #e4e4e4;
            font-family: 'big_noodle_titling';
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
            text-align: center;
          }
          .extra-action_signup {
            display: block;
          }
          p,
          .extra-action_signup {
            color: white;

            margin-top: 24px;
            font-family: 'Roboto-Medium';
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: center;
          }
          .extra-action_signup {
            text-decoration: underline;
          }
          .extra-action_signup:hover {
            color: #fd0300;
          }
          .extraAction {
            display: block;
            margin-top: 45px;
            color: #757575;
            text-transform: uppercase;
            letter-spacing: 0.12em;
          }
          .action_buttons {
            width: 100%;
            display: flex;
            justify-content: space-between;
          }
          .cancel_button {
            height: 48px;
            width: 100%;
            margin-right: 5%;
            color: white;
            background: #000000;
            border: 1px solid #e4e4e4;
            font-family: 'Roboto-Medium';
            font-size: 13px;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 24px;
            border-radius: 3px;
            outline: 0;
          }
          .cancel_button:hover {
            background: #e4e4e4;
            color: #000000;
          }
          @media (max-width: ${breakPoints.small}) {
            .reset-password-request-from-container {
              max-width: 340px;
            }
          }
        `}
      </style>
    </div>
  );
};

RequestForm.propTypes = {
  onCancle: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

export default RequestForm;
